import { Controller } from "@hotwired/stimulus";

// Native confirmation prompt before submitting a form. Use this instead of
// `data-turbo-confirm` when the form opts out of Turbo (`data-turbo="false"`),
// where Turbo's own confirm never fires.
//
//   <%= form_with ..., data: { turbo: false, controller: "confirm",
//         confirm_message_value: "Are you sure?", action: "submit->confirm#check" } %>
export default class extends Controller {
  static values = { message: String };

  check(event) {
    if (!window.confirm(this.messageValue)) {
      event.preventDefault();
    }
  }
}
